import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Logcontrol from '../views/Logcontrol.vue'
import Logaudit from '../views/Logaudit.vue'
import Logdetails from '../views/Logdetails.vue'
import Logcheck from '../views/LogCheck.vue'
import LogElastic from '../views/LogElastic.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

// @ts-ignore
const ifAutenticated = (to, from, next) => {
  if (localStorage.getItem('authorization')) {
    next()
    return
  }
  next('/login')
}
const routes: Array<RouteConfig> = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/',
    name: 'Logcontrol',
    beforeEnter: ifAutenticated,
    component: Logcontrol,
    meta: {
      title: 'Log control',
    },
  },
  {
    path: '/audit/',
    name: 'Logaudit',
    beforeEnter: ifAutenticated,
    component: Logaudit,
    meta: {
      title: 'Log audit',
    },
    children: [
      {
        path: ':id',
        name: 'Logdetails',
        component: Logdetails,
        meta: {
          title: 'Log details',
        },
      },
    ],
  },
  {
    path: '/check',
    name: 'Logcheck',
    beforeEnter: ifAutenticated,
    component: Logcheck,
    meta: {
      title: 'Apps check',
    },
  },
  {
    path: '/elastic',
    name: 'LogElastic',
    beforeEnter: ifAutenticated,
    component: LogElastic,
    meta: {
      title: 'Elastic control',
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

export default router
